import React from 'react';
import styled from 'styled-components';
import {ScrollBar} from '../../shared-components/mixin/scroll/scrollBar';
import {FooterSizeSetup} from './page-features/PageSizeSetup';

const Footer = ({children, size}) => <FooterWrapper className={size}>{children}</FooterWrapper>;

const FooterWrapper = styled(ScrollBar)`
    ${FooterSizeSetup}
    grid-area: footer;

    height: var(--footer-height);
    width: 100%;
    padding: var(--grid-padding);

    overflow-y: auto;
    overflow-x: hidden;
    z-index: var(--z-index-footer);
    background: var(--container-background-color-600);
    box-shadow: var(--container-shadow-color-500);
    overflow-y: auto;
    overflow-x: hidden;

    @-moz-document url-prefix() {
        overflow-y: auto;
        scrollbar-color: var(--scroll-bar-background) var(--scroll-bar-thumb);
    }
`;

export {Footer, FooterWrapper};
